import { render, staticRenderFns } from "./MapPrescriber.vue?vue&type=template&id=54707e4a&scoped=true&"
import script from "./MapPrescriber.vue?vue&type=script&lang=ts&"
export * from "./MapPrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./MapPrescriber.vue?vue&type=style&index=0&id=54707e4a&lang=scss&scoped=true&"
import style1 from "./MapPrescriber.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54707e4a",
  null
  
)

export default component.exports